import {
  AssetFillState,
  AssetStatus,
  Weight,
  WeightInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

const convertWeightToWeightInput = (weight: Weight | null): WeightInput => {
  if (!weight || !weight.value) {
    return {
      value: 0,
      unit: 'Pounds',
    };
  }
  return {
    value: weight.value,
    unit: weight.unit,
  };
};

export const useCreateAssetMutation = createMutationHook(
  'transportation.assetCreate',
  (params: {
    identifier: string;
    typeId: string;
    description: string;
    status: AssetStatus;
    fillState: AssetFillState;
    customAttributes: Record<string, unknown>;
    tareWeight: Weight | null;
  }) => ({
    transportationAssetCreate: {
      __args: {
        input: {
          identifier: params.identifier,
          typeId: params.typeId,
          description: params.description,
          status: params.status,
          fillState: params.fillState,
          customAttributes: params.customAttributes,
          tareWeight: convertWeightToWeightInput(params.tareWeight),
        },
      },
      id: true,
      identifier: true,
      description: true,
      status: true,
      type: {
        id: true,
        name: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
